import gql from 'graphql-tag';

export const DASHBOARD_METRICS_QUERY = gql`
	query DashboardMetrics(
		$startOfToday: DateTime!
		$endOfToday: DateTime!
		$entriesWindowStart: DateTime!
		$insideListLimit: Int = 10
	) {
		recentEntries: parkingSessionsEntryPerDay(
			first: 30
			order: [{ entryDate: ASC }]
			where: { entryDate: { gte: $entriesWindowStart } }
		) {
			nodes {
				entryDate
				itemsCount
			}
		}

		todayEntries: parkingSessionsEntryPerDay(
			first: 5
			where: {
				entryDate: { gte: $startOfToday, lte: $endOfToday }
			}
		) {
			nodes {
				entryDate
				itemsCount
			}
		}

		todayExits: parkingSessionsExitPerDay(
			first: 5
			where: { exitDate: { gte: $startOfToday, lte: $endOfToday } }
		) {
			nodes {
				exitDate
				itemsCount
			}
		}

		parkingSessionsPerStatus {
			isInside
			itemsCount
		}

		parkingSessionsInsideOnReservations {
			itemsCount
		}

		parkingSessionsInsideOnContracts(
			first: 30
			fromDate: $startOfToday
			toDate: $endOfToday
			order: [{ entryDate: DESC }]
		) {
			nodes {
				entryDate
				itemsCount
			}
		}

		parkingSessionsActiveReservations {
			itemsCount
		}

		insideReservationSessions: parkingSessions(
			first: $insideListLimit
			order: [{ entryDateTime: DESC }]
			where: { status: { eq: INSIDE } }
		) {
			nodes {
				parkingSessionId
				ticketId
				entryDateTime
				status
				vehicle {
					plateNumber
					make
					model
					color
				}
				customer {
					firmName
					firstName
					lastName
					isCompany
				}
				reservations {
					reservationId
					reservationStartTime
					reservationEndTime
					reservationStatus {
						name
					}
				}
			}
		}
	}
`;
